import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toast"]

  connect() {
    this.toastTargets.forEach((toast) => {
      setTimeout(() => this.closeToast(toast), 5000) // Auto-close after 5 seconds
    })
  }

  close(event) {
    event.preventDefault()
    const toast = event.target.closest("[data-toast-target='toast']")
    this.closeToast(toast)
  }

  closeToast(toast) {
    toast.classList.add("translate-x-full", "opacity-0")
    setTimeout(() => toast.remove(), 300) // Wait for transition to finish
  }
}
